import {create} from "zustand";

type CatalogFilterDrawerStore = {
    opened: boolean;
    filterKey: string | null;
    actions: {
        openModal: (filterKey: string) => void;
        closeModal: () => void;
    }
};
export const useCatalogFilterDrawer = create<CatalogFilterDrawerStore>((set) => ({
    opened: false,
    filterKey: null,
    actions: {
        openModal: (filterKey) => set({opened: true, filterKey}),
        closeModal: () => set({opened: false, filterKey: null}),
    },
}));
